import EditorialConfig from '@/editorial-config';

const getTimestampInSeconds = () => {
    return Math.floor(
        new Date(new Date().toLocaleString('en', { timeZone: EditorialConfig.timezone })).getTime() / 1000,
    );
};

export { getTimestampInSeconds };
